module.exports = __webpack_public_path__ + "6e8aeebd12e814ce19d836bee541b069.svg";